import { totalViewsConfig } from '../totalViews';
import { SIZE_50 } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerViewsConfig = {
    ...totalViewsConfig,
    id: 'video_views',
    name: 'kpi.twitter.mediaviewer.views',
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
